import { query_customer_remain_info_list } from '@/api/mjstore-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
  config,
} from '@/components/page-model/mjstat/mjstat-customerremainliang-config';

import { reactive } from 'vue';
import moment from 'moment';
import { get_gender, getDate, getDateMonth, toFixed0 } from '@/utils/function';

const None = null;
const True = true;
const False = false;

export default () => {
  const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
  const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店

  const search_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'inline',
    },
    fields: [
      // {
      //   type: 'remotemodal',
      //   name: 'customer_id',
      //   label: '会员姓名',
      //   disabled: false,
      //   placeholder: '请选择会员姓名',
      //   datasourceType: 'remote',
      //   mode: 'default',
      //   allowClear: true,
      //   modalType: 'mjstore-customer',
      // },
      // {
      //   type: 'input',
      //   name: 'customer_code',
      //   label: '会员编号',
      //   disabled: false,
      //   allowClear: true,
      //   inputType: 'text',
      //   defaultValue: '',
      //   placeholder: '请填写会员编号',
      // },
      {
        type: 'input',
        name: 'customer_name',
        label: '会员姓名',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        defaultValue: '',
        placeholder: '请填写会员姓名',
      },
      {
        type: 'remoteselect',
        name: 'shop_id',
        label: '会籍门店',
        disabled: false,
        placeholder: '请选择会籍门店',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-shop',
      },
      // {
      //   type: 'datepicker',
      //   name: 'query_date',
      //   label: '时间节点',
      //   disabled: false,
      //   allowClear: true,
      //   inputType: 'number',
      //   defaultValue: '',
      //   valueFormat: 'YYYY-MM-DD',
      //   format: 'YYYY-MM-DD',
      //   showTime: false,
      //   placeholder: '请填写时间节点',
      // },
    ],
    rules: {
      // query_date: [{ required: true, message: '请填写时间节点' }],
    },
    model: reactive({
      org_id: current_org?.id,
      is_active: true,
      shop_id: null,
      customer_code: null,
      customer_id: null,
      customer_name: null,
      pageSize: 200000,
      // query_date: moment().format('YYYY-MM-DD'),
    }),
  };
  const search_options = {};

  const edit_model_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'horizontal',
      col: config.creatCol,
    },
    fields: [],
    rules: {},
    model: reactive({
      org_id: current_org?.id,
      is_active: true,
    }),
  };
  const edit_model_config_options = {};

  const update_model_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'horizontal',
      col: config.creatCol,
    },
    fields: [],
    rules: {},
    model: reactive({
      org_id: current_org?.id,
      is_active: true,
    }),
  };
  const update_model_config_options = {};

  const titleList = {
    title: '余额余项量',
    addModalTitle: '新建等级变动记录',
    updateTitle: '修改等级变动记录',
    is_create: false, // 是否有【新建】按钮
    is_update: false, // 是否有【修改】按钮
    is_remove: false, // 是否有【删除】按钮
    is_recover: false, // 是否有【恢复】按钮
  };

  const api_fields: Record = {
    update: {
      id: 'id',
    },
    delete: {
      id: 'id',
    },
    recover: {
      id: 'id',
    },
    updateData: {
      org_id: 'org_id',
      id: 'id',
    },
  };

  const baseColumns: TableColumn[] = [
    {
      title: '序号',
      dataIndex: 'idx',
      width: 80,
      fixed: 'left',
    },
    {
      title: '会员编号',
      width: 140,
      dataIndex: 'code',
      checked: true,
      fixed: 'left',
    },
    {
      title: '会员姓名',
      width: 100,
      dataIndex: 'name',
      checked: true,
      fixed: 'left',
    },
    {
      title: '会籍门店',
      width: 150,
      dataIndex: 'shop__name',
      checked: true,
    },
    {
      title: '所属顾问',
      width: 150,
      dataIndex: 'adviser__name',
      checked: true,
    },
    {
      title: '性别',
      width: 150,
      dataIndex: 'gender',
      checked: true,
      content: (record: any, text: any) => {
        return get_gender(text);
      },
    },
    {
      title: '建档日期',
      width: 150,
      dataIndex: 'join_date',
      checked: true,
    },
    {
      title: '手机号',
      width: 150,
      dataIndex: 'phone',
      checked: true,
    },
    {
      title: '获客方式',
      width: 150,
      dataIndex: 'hk_type__name',
      checked: true,
    },
    {
      title: '充值余额',
      width: 120,
      dataIndex: 'price_cz',
      checked: true,
      content: (record: any, text: any) => {
        return toFixed0(text);
      },
    },
    {
      title: '返利余额',
      width: 120,
      dataIndex: 'price_fl',
      checked: true,
      content: (record: any, text: any) => {
        return toFixed0(text);
      },
    },
    {
      title: '总余额',
      width: 120,
      dataIndex: 'price_total',
      checked: true,
      content: (record: any, text: any) => {
        return toFixed0(text);
      },
    },
    {
      title: '类型',
      width: 150,
      dataIndex: 'type_str',
      checked: true,
    },
    {
      title: '项目',
      width: 150,
      dataIndex: 'project_name',
      checked: true,
    },
    {
      title: '项目类型',
      width: 150,
      dataIndex: 'type_name',
      checked: true,
    },
    {
      title: '余次',
      width: 150,
      dataIndex: 'now_num',
      checked: true,
    },
    {
      title: '到期时间',
      width: 150,
      dataIndex: 'end_date',
      checked: true,
      content: (record: any, text: any) => {
        return getDate(text);
      },
    },
  ];
  const newSlotList: any = [];
  Object.assign(newSlotList, slotList);
  newSlotList.push({
    type: 'custom',
    slotName: 'is_active',
    field_true: '可用',
    field_false: '作废',
  });

  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_customer_remain_info_list,
    addData: None,
    updateData: None,
    removeData: None,
    recoverData: None,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
    rowKey: '_index',
    pageSizeOptions: [100000, 200000],
  };
};
